<template>
  <div class="app-main-content intelligent-booking">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_UniversalIntelligentRecognition')" name="generalTestFile" style="width:100%;height: 100%">
          <general-test-file ref="generalTestFile" :tab-title="$t('CargoMsg.Cargo_UniversalIntelligentRecognition')" />
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>

<script>

import GeneralTestFile from '@/views/cargo/v0/ToolAssistant/general/generalTestFile.vue'

export default {
  name: 'GeneralRecognition',
  components: { GeneralTestFile },
  data() {
    return {
      activeTabName: 'generalTestFile'
    }
  },
  activated() {},
  async created() {
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
